<form [formGroup]="form" class="form" *ngIf="form">
  <div class="form-body">
    <div class="form-section">
      <h2 class="h5 modal-body-title">
        {{ isSystemAdmin ? 'Invite Superadmin' : 'FORMS.BRANCH.INVITE_TEAM_MEMBER.INVITE_TEAM_MEMBER_TITLE' | translate }}
      </h2>

      <ng-container *ngFor="let invitee of invitees.controls; let i = index">
        <app-form-row [label]="(i === 0) ?
          ('FORMS.BRANCH.INVITE_TEAM_MEMBER.EMAIL' | translateControl : invitee | async)
          : ''
        ">
          <div class="row">
            <div [ngClass]="isSystemAdmin ? 'col-12' : 'col-11'">
              <app-input [type]="'text'" [mainForm]="invitee" [controlName]="'email'"
                [placeholder]="'FORMS.BRANCH.INVITE_TEAM_MEMBER.EMAIL'">
              </app-input>
            </div>
            <button *ngIf="!isSystemAdmin" class="btn btn_link btn_icon btn_delete" [disabled]="invitees.controls.length === 1"
              (click)="removeInvitee(i)" svgIcon [icon]="'delete'">
            </button>
          </div>
          <ng-container *ngIf="!isSystemAdmin && i === (invitees.controls.length - 1) && invitees.controls.length < MAX_AMOUNT_INVITEES">
            <div class="form-controlAction">
              {{ 'GENERAL.OR' | translate | titlecase }}
              <button class="btn btn_link btn_icon" (click)="addInvitee()" svgIcon [icon]="'plus'">
                {{ 'FORMS.BRANCH.INVITE_TEAM_MEMBER.INVITE_MORE_USERS' | translate }}
              </button>
            </div>
          </ng-container>
        </app-form-row>
      </ng-container>

      <ng-container *ngIf="!branchId || isSystemAdmin">

        <app-form-row *ngIf="isSystemAdmin" [label]="'Account Types'">
          <app-dropdown [options]="dropdownData.accountTypes" [labelKey]="'title'" [valueKey]="'value'" [mainForm]="form"
            [controlName]="'accountType'" (onClose)="onAccountTypeChange($event)">
          </app-dropdown>
        </app-form-row>

        <!-- <app-form-row *ngIf="isSystemAdmin" [label]="'Organization'">
          <app-dropdown [options]="dropdownData.organizations" [labelKey]="'title'" [valueKey]="'value'" [mainForm]="form"
            [controlName]="'organization'">
          </app-dropdown>
        </app-form-row> -->

          <app-form-row *ngIf="!isSystemAdmin && isDealer"
            [label]="'FORMS.BRANCH.INVITE_TEAM_MEMBER.BRANCHES' | translateControl : form | async">
            <app-dropdown [options]="dropdownData.branches" [labelKey]="'title'" [valueKey]="'value'" [mainForm]="form"
              [controlName]="'branches'" [multiple]="true">
            </app-dropdown>
          </app-form-row>

        <app-form-row *ngIf="isSystemAdmin" [label]="'Organization'">
          <ng-select
            [items]="dropdownData.organizations"
            [bindLabel]="'title'"
            [bindValue]="'value'"
            [formControl]="form.get('organization')"
            [clearable]="false">
          </ng-select>
        </app-form-row>

        <app-form-row *ngIf="!isSystemAdmin" [label]="'FORMS.BRANCH.INVITE_TEAM_MEMBER.ROLE' | translateControl : form | async">
          <app-dropdown [options]="dropdownData.roles" [labelKey]="'title'" [valueKey]="'value'" [mainForm]="form"
            [controlName]="'role'">
          </app-dropdown>
        </app-form-row>
      </ng-container>
    </div>
  </div>
</form>
